
import { useEffect, useState } from "react";
import { apiGet, apiPost } from '../../API/httpCommon';
import { setEmitFlags } from "typescript";
import Spinner from '../Spinner/Spinner';
import { OrderOutsideIndiaUtilityAddUpdate, GetOrderOutsideIndia, RemoveAllOrderOutsideIndia } from '../../Utility/OrderOutsideIndiaUtility'
import { AddUpdateCart, GetCart } from '../../Utility/CartUtility';


const OrderOutsideIndia = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [itemOrderOutsideIndia, setItemOrderOutsideIndia] = useState<any[]>([]);

    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [Phone , setPhone ] = useState('');
    const [City , setCity ] = useState('');
    const [State , setState ] = useState('');
    const [Country , setCountry ] = useState('');
    const [Pincode , setPincode ] = useState('');
    const [ShippingAddress , setShippingAddress ] = useState('');
    const [Remarks  , setRemarks] = useState('');

    const [Message  , setMessage] = useState('');
    const [Status  , setStatus] = useState('');

    const [CaptchaText, setCaptchaText] = useState('');
    const [UserCaptchaText, setUserCaptchaText] = useState('');
    const [IsCaptchaValid, setIsCaptchaValid] = useState(true);

    useEffect(function () {
        setItemOrderOutsideIndia(GetOrderOutsideIndia());
        generateCaptchaText();
    }, []);

    const deleteOrderOutsideIndia = (item: any) => {
        
        setIsLoading(true);
        const response = OrderOutsideIndiaUtilityAddUpdate(item, 'Delete', null, null);
        setTimeout(() => {
            setItemOrderOutsideIndia(GetOrderOutsideIndia());
            setIsLoading(false);
        }, 500);
      
    }

    const QuantityUpdateOrderOutsideIndia = (Type: any, Item_Id: any, Index: any) => {
        
        let Qty = 0
        if (Type === 'Add') {
            Qty = parseInt(itemOrderOutsideIndia[Index].Quantity) + 1;
            OrderOutsideIndiaUtilityAddUpdate(itemOrderOutsideIndia, 'Update', Index, Qty);
        }
        else if (Type === 'Sub' && parseInt(itemOrderOutsideIndia[Index]?.Quantity) > 1) {
            Qty = parseInt(itemOrderOutsideIndia[Index].Quantity) - 1;
            OrderOutsideIndiaUtilityAddUpdate(null, 'Update', Index, Qty);
        }
        setItemOrderOutsideIndia(GetOrderOutsideIndia());
    }


     const isValidForm = () =>{

        let result : boolean = true;

        if(!Name){ result = false;  }
        if(!Email){ result = false;  }
        if(!Phone){ result = false;  }
        if(!City){ result = false;  }
        if(!State){ result = false;  }
        if(!Country){ result = false;  }
        if(!Pincode){ result = false;  }
        if(!ShippingAddress){ result = false;  }
        if(!itemOrderOutsideIndia){ result = false;  }

         setIsCaptchaValid(true);
         if(UserCaptchaText !== CaptchaText){
            result = false;
            setIsCaptchaValid(false);
            generateCaptchaText();
            setUserCaptchaText('');
        
         }
        
        return result;

     }



     const RequestOrder = () =>{

        
        if(!isValidForm()){
            alert('Please enter required fields');
            return false;
        }


        let data = {
            Name : Name,
            Email : Email,
            Phone : Phone,
            City : City,
            State : State,
            Country : Country,
            Pincode : Pincode,
            Address : ShippingAddress,
            Remarks : Remarks,
            ItemList : itemOrderOutsideIndia
        }
        setIsLoading(true);
        apiPost("api/Order/OrderOutsideIndia", data).then((res: any) => {
            
          
            if(res?.IsSuccess){
                setName('');
                setEmail('');
                setPhone('');
                setCity('');
                setState('');
                setCountry('');
                setPincode('');
                setShippingAddress('');
                setRemarks('');
                setMessage(' Thank you. We have received your request. We will get back to you soon');
            }
            else{
                setMessage('Something went wrong. Please contact us.');
            }
            setStatus(res?.IsSuccess.toString());
            setTimeout(() => {
              setIsLoading(false);
              }, 2000);

              RemoveAllOrderOutsideIndia();
              setItemOrderOutsideIndia(GetOrderOutsideIndia());

        });


     }

    const generateCaptchaText = () => {
       
        const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        let result = "";
        for (let i = 0; i < 5; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        setCaptchaText(result);
    };



    return (<>
        {(isLoading && <Spinner></Spinner>)}
        {/* <!-- Breadcumb Section Start --> */}
        <div className="breadcrumb-img">
            <img src="/assets/img/banner/OrderOutsideIndia-banner.jpg" alt="MeriPustak-About" />

        </div>

        <section className="contact-section fix section-padding">
            <div className="container">
                <div className="contact-wrapper">
                    <div className="row g-4">
                        <div className="col-lg-5">
                            <div className="contact-left-items">
                                <h3 className="wow fadeInUp" data-wow-delay=".3s" style={{ visibility: "visible", animationDelay: "0.3s", animationName: "fadeInUp" }}>Our services are available outside India and we are sending books shipment across the world.</h3>
                                <p className="wow fadeInUp" data-wow-delay=".3s" style={{ visibility: "visible", animationDelay: "0.3s", animationName: "fadeInUp" }}>Except for few countries where high courier charges or no logistic support is feasible/available</p>
                                <h3 className="wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>Outside India Order Request Process</h3>
                                <p className="wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}><b>Step-1</b></p>
                                <p className="wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>Before placing your request please check the title selling should not limited to a country or region specific.</p>
                                <p className="wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>In addition to the book price the courier &amp; payment transaction charge will be applicable to all orders.</p>
                                <p className="wow fadeInUp" data-wow-delay=".7s" style={{ visibility: "visible", animationDelay: "0.7s", animationName: "fadeInUp" }}><b>Step 2</b></p>
                                <p className="wow fadeInUp" data-wow-delay=".7s" style={{ visibility: "visible", animationDelay: "0.7s", animationName: "fadeInUp" }}>After receiving the order request, we will share the order payment link with the invoice. The total price includes the shipping charge. after confirmation of payment, we will ship the order. on average, the order will reach within 7-8 business days (in most of the countries).</p>
                                <p className="wow fadeInUp" data-wow-delay=".7s" style={{ visibility: "visible", animationDelay: "0.7s", animationName: "fadeInUp" }}>We sell 100% new &amp; genuine copy and 90% + of our sourcing is directly from publishers and publisher's authorized distributor .</p>

                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="contact-content">
                                <h2 className="wow fadeInUp" data-wow-delay=".3s" style={{ visibility: "visible", animationDelay: "0.3s", animationName: "fadeInUp" }}>Information:-</h2>

                                <div  id="contact-form" className="contact-form-items">
                                    <div className="row">

                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s" style={{ visibility: "visible", animationDelay: "0.3s", animationName: "fadeInUp" }}>
                                            <div className="form-clt">
                                                <span>Your name*</span>
                                                <input type="text" value={Name} onChange={(e) => {setName(e.target.value)}} name="name" id="name" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                            <div className="form-clt">
                                                <span>Your Email*</span>
                                                <input type="email"  value={Email} onChange={(e) => {setEmail(e.target.value)}}  name="email" id="email" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                            <div className="form-clt">
                                                <span>Phone No.*</span>
                                                <input type="number"   value={Phone} onChange={(e) => {setPhone(e.target.value)}}  name="phone" id="phone" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                            <div className="form-clt">
                                                <span>City*</span>
                                                <input type="text"   value={City} onChange={(e) => {setCity(e.target.value)}}  name="City" id="City" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                            <div className="form-clt">
                                                <span>State*</span>
                                                <input type="text"   value={State} onChange={(e) => {setState(e.target.value)}}   name="State" id="State" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                            <div className="form-clt">
                                                <span>Country*</span>
                                                <input type="text"   value={Country} onChange={(e) => {setCountry(e.target.value)}}  name="Country" id="Country" placeholder="" />
                                            </div>
                                        </div>

                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                            <div className="form-clt">
                                                <span>Postal(ZIP) Code*</span>
                                                <input type="text"   value={Pincode} onChange={(e) => {setPincode(e.target.value)}}  name="Country" id="Country" placeholder="" />
                                            </div>
                                        </div>

                                        {/* <div className="col-lg-12 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                            <br /><div className="row wow fadeInUp" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                                                <div className="col-lg-1 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                                    <div className="form-clt">
                                                        <span>SNo.</span>
                                                        <p>1.</p>
                                                    </div>

                                                </div>
                                                <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                                    <div className="form-clt">
                                                        <span>Book Name</span>
                                                        <p>Securities Contract Regulation Act, 1956 alongwith Rules As amended by the Finance Act, 2023</p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                                    <div className="form-clt">
                                                        <span>ISBN</span>
                                                        <p>9789356038509</p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                                    <div className="form-clt">
                                                        <span>Qty.</span>
                                                        <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                            <input type="number" name="qty" id="qty2" min="1" max="10" step="1" value="1" />
                                                            <a className="remove-icon"><img src="assets/img/icon/icon-9.svg" alt="img" /></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div><br />
                                        </div> */}

                                        <div className="cart-section section-padding">
                                            <div className="container">
                                                <div className="main-cart-wrapper">
                                                    <div className="row g-5">
                                                        <div className="col-xl-12">

                                                            <div className="table-responsive m-hidden">
                                                                <table className="table">
                                                                    <tbody>
                                                                        <tr className="border">
                                                                            <td>
                                                                                {
                                                                                    itemOrderOutsideIndia?.map((item: any, index: any) =>
                                                                                    (
                                                                                        <div className="cart-title">
                                                                                            <a onClick={() => deleteOrderOutsideIndia(item)} className="remove-icon mremove-icon">
                                                                                                <img src="assets/img/icon/icon-9.svg" alt="img" />
                                                                                            </a>

                                                                                            <div className="col-xl-12">
                                                                                                <span className="d-flex gap-5 align-items-center">
                                                                                                    <span className="cart-title">
                                                                                                        <a href={"/" + item?.Item_Title_Url + "-" + item?.Item_Id}>   {item?.Item_Title}</a>
                                                                                                    </span>
                                                                                                </span><br />
                                                                                                <div>
                                                                                                    <span className="d-flex align-items-center">
                                                                                                        <span className="quantity-basket">
                                                                                                            <span className="qty" style={{ margin: "0 10px" }}>
                                                                                                                <button className="qtyminus" aria-hidden="true" onClick={() => { QuantityUpdateOrderOutsideIndia('Sub', item?.Item_Id, index) }} >−</button>
                                                                                                                <input type="number" name="qty" id="qty2" min="1" max="10" step="1"
                                                                                                                    value={item?.Quantity} />
                                                                                                                <button className="qtyplus" aria-hidden="true" onClick={() => { QuantityUpdateOrderOutsideIndia('Add', item?.Item_Id, index) }} >+</button>

                                                                                                            </span>
                                                                                                        </span>
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <hr></hr>
                                                                                        </div>

                                                                                    )

                                                                                    )
                                                                                }

                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>



                                                            <div className="table-responsive desk-hidden">

                                                                <table className="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="cart-border-none">Item Name</th>
                                                                            <th className="cart-border-none">Qty</th>
                                                                            <th className="cart-border-none"></th>
                                                                        </tr>
                                                                        <tr className="border-bottom"></tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            itemOrderOutsideIndia?.map((item: any, index: any) =>
                                                                            (
                                                                                <tr>
                                                                                    <td className="cart-border-none">
                                                                                        <span className="d-flex gap-5 align-items-center">
                                                                                            <span className="cart-title">
                                                                                                <a href={"/" + item?.Item_Title_Url + "-" + item?.Item_Id}>   {item?.Item_Title}</a>
                                                                                            </span>
                                                                                        </span>
                                                                                    </td>

                                                                                    <td className="cart-border-none">
                                                                                        <span className="quantity-basket">
                                                                                            <span className="qty">
                                                                                                {(item?.Quantity === 1) && <button className="qtyminus" aria-hidden="true" onClick={() => deleteOrderOutsideIndia(item)} > <i className='fas fa-trash-alt' style={{ fontSize: "16px" }} ></i> </button>}
                                                                                                {(item?.Quantity > 1) && <button className="qtyminus" aria-hidden="true" onClick={() => { QuantityUpdateOrderOutsideIndia('Sub', item?.Item_Id, index) }} >−</button>}
                                                                                                <input type="number" name="qty" id="qty2" min="1" max="10" step="1"
                                                                                                    value={item?.Quantity} />
                                                                                                <button className="qtyplus" aria-hidden="true" onClick={() => { QuantityUpdateOrderOutsideIndia('Add', item?.Item_Id, index) }} >+</button>
                                                                                            </span>
                                                                                        </span>
                                                                                    </td>

                                                                                    <td className="cart-border-none">
                                                                                        <span className="d-flex gap-5 align-items-center">
                                                                                            <a onClick={() => deleteOrderOutsideIndia(item)} className="remove-icon">
                                                                                                <img src="assets/img/icon/icon-9.svg" alt="img" />
                                                                                            </a>
                                                                                        </span>
                                                                                    </td>
                                                                                </tr>
                                                                            )

                                                                            )
                                                                        }

                                                                        {((itemOrderOutsideIndia === undefined || itemOrderOutsideIndia === null || itemOrderOutsideIndia.length === 0)) &&
                                                                            (
                                                                                <>
                                                                                    <tr>
                                                                                        <td colSpan={5}>No Item added in cart</td>
                                                                                    </tr>
                                                                                </>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <div className="border"></div>
                                                            </div>

                                                        </div>


                                                        


                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp" }}>
                                            <div className="form-clt">
                                                <span>Complete Shipping Address*</span>
                                                <textarea name="Address" value={ShippingAddress} onChange={(e) => {setShippingAddress(e.target.value)}} id="Address" placeholder=""></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".7s" style={{ visibility: "visible", animationDelay: "0.7s", animationName: "fadeInUp" }}>
                                            <div className="form-clt">
                                                <span>Remarks (if any)</span>
                                                <textarea name="Remarks"  value={Remarks} onChange={(e) => {setRemarks(e.target.value)}} id="Remarks" placeholder=""></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 wow fadeInUp" data-wow-delay=".9s" style={{ visibility: "visible", animationDelay: "0.9s", animationName: "fadeInUp" }}>
                                            <br />
                                              <span>{CaptchaText}</span> 
                                             {" "} <i style={{fontSize:"24px", cursor:"pointer"}} onClick={generateCaptchaText} className="fa"  >&#xf021;</i>{" "}
                                              
                                              {" "}  <input type="text" style={{borderRadius:"1px"}} value={UserCaptchaText}  onChange={(e: any) => { setUserCaptchaText(e.target.value) }} name="Enter Captcha" id="Captcha" placeholder="Enter Captcha" />
                                              {"  "} 
                                              {IsCaptchaValid === false ? "Invalid Captcha" : ""}
                                            {((itemOrderOutsideIndia !== undefined && itemOrderOutsideIndia !== null && itemOrderOutsideIndia?.length > 0)) &&
                                                (
                                                    <button type="submit" className="theme-btn" onClick={RequestOrder}>
                                                Request Order <i className="fa-solid fa-arrow-right-long"></i>
                                            </button>
                                                )
                                            }

                                           
                                                  &nbsp;  <a href="/" className="theme-btn btnpnk">Continue Shopping</a>
                                              <br></br>
                                                { (Message && Status !== '') &&  <h3>  <span style={{color : (Status === "true" ? "green" : "red") }}>{Message}</span> </h3> }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


    </>);
}

export default OrderOutsideIndia;